import React, { useState, useEffect } from "react";
import { all_routes } from "../../../router/all_routes";
import PageHeader from "../../../../core/common/crmComponents/PageHeader";
import LoaderComponent from "../../../../core/common/crmComponents/LoaderComponent";
import { useParams } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { fetchTimelineData } from "../../../../utils/helpers/apiHelpers";
import DisplayTimeline from "../../../../core/common/crmComponents/DisplayTimeline";
import { MODULES } from "../../../../core/data/constants/moduleConstants";
import DuplicateLeadPipelineStatus from "../components/DuplicateLeadPipelineStatus";
import DuplicateLeadDetailsSidebar from "../components/DuplicateLeadDetailsSidebar";
import DuplicateLeadDetailsHeader from "../components/DuplicateLeadDetailsHeader";
import { useDuplicateLeadData } from "../hooks/useDuplicateLeadData";
import { useDispatch, useSelector } from "react-redux";
import queryClient from "../../../../config/queryClient";
import { setReloading } from "../../../../core/data/redux/moduleDataSlice";

const DuplicateLeadsDetails = () => {
  const route = all_routes;
  const { id: leadId } = useParams();
  const { leadData, isLoading, isError, error } = useDuplicateLeadData(leadId);
  const dispatch = useDispatch();
  const reloading = useSelector((state) => state.moduleData.reloading);

  const [view, setView] = useState("overview"); // State for view

  useEffect(() => {
    if (reloading) {
      queryClient.invalidateQueries(["duplicateLead", leadId]);
      dispatch(setReloading(false));
    }
  }, [reloading, dispatch]);

  const {
    data: timelineData,
    isLoading: timelineLoading,
    isError: timelineError,
  } = useQuery({
    queryKey: ["timelineData", leadId],
    queryFn: () => fetchTimelineData(leadData?.timeline),
    enabled: !!leadData?.timeline && view == "timeline",
    staleTime: Infinity,
  });

  if (timelineError) return <div>Error loading timeline data.</div>;

  const renderContent = () => {
    if (view === "overview") {
      return (
        <>
          {/* <DuplicateLeadPipelineStatus leadData={leadData} /> */}
          <DuplicateLeadDetailsSidebar leadData={leadData} />
        </>
      );
    } else if (view === "timeline") {
      return timelineLoading ? (
        <LoaderComponent />
      ) : (
        <>
          {timelineData && Object.keys(timelineData).length > 0 && (
            <DisplayTimeline
              timeline={timelineData}
              selectedData={leadData}
              moduleName={MODULES.DUPLICATELEADS}
            />
          )}
        </>
      );
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <PageHeader
              pageName="Duplicate Lead Overview"
              moduleName="duplicateLead"
            />
          </div>
        </div>
        <div className="row">
          {isLoading ? (
            <LoaderComponent />
          ) : isError ? (
            <div className="col-md-12">
              <div className="alert alert-danger text-capitalize" role="alert">
                {error?.response?.data?.msg}
              </div>
            </div>
          ) : (
            <DuplicateLeadDetailsHeader
              leadData={leadData}
              view={view}
              setView={setView} // Pass the setter function
            />
          )}
        </div>
        <div className="row">{renderContent()}</div>
      </div>
    </div>
  );
};

export default DuplicateLeadsDetails;
